import { render, staticRenderFns } from "./ImportantInfoWidget.vue?vue&type=template&id=5039fac7"
import script from "./ImportantInfoWidget.vue?vue&type=script&lang=js"
export * from "./ImportantInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./ImportantInfoWidget.vue?vue&type=style&index=0&id=5039fac7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports